import axios from "axios";

export const createPromoCodeRequest = async (testMode, formValues) => {
  console.log("Creating promo code");
  try {
    let requestUrl = testMode
      ? "/api/test-promo-code/create-promo-code"
      : "/api/promo-code/create-promo-code";

    // TO-DO: Replace below with real data from parameters
    let requestBody = {
      ...formValues,
    };

    let res = await axios.post(requestUrl, requestBody, {
      headers: { "Content-Type": "application/json" },
    });
    return res.data;
  } catch (err) {
    console.log(err.response);
    return err;
  }
};
